const HEALTH_CALC_DRAWER_IDS = new Set(['calorie-calculator-drawer', 'bmi-calculator-drawer']);

function handleHealthCalcTriggerClick(event) {
  const trigger = event.target.closest('[aria-controls]');
  if (!trigger) return;

  const drawerId = trigger.getAttribute('aria-controls');
  if (!HEALTH_CALC_DRAWER_IDS.has(drawerId)) return;

  event.preventDefault();
  event.stopPropagation();

  const drawer = document.getElementById(drawerId);
  if (drawer && typeof drawer.open === 'function') {
    drawer.open(trigger);
  }
}

class HealthCalcDrawer extends HTMLElement {
  constructor() {
    super();

    this.onBackdropClick = this.onBackdropClick.bind(this);
    this.addEventListener('click', this.onBackdropClick);
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.closeButton = this.querySelector('.drawer__close');
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }
  }

  onBackdropClick(event) {
    if (!this.classList.contains('active')) return;

    const panel = this.querySelector('.drawer__inner');
    if (panel && event.target.closest('.drawer__inner')) return;

    this.close();
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;

    if (triggeredBy) this.activeElement = triggeredBy;

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const focusElement = this.querySelector('.drawer__close') || this.querySelector('.drawer__inner');
        if (typeof trapFocus === 'function') {
          trapFocus(this.querySelector('.drawer__inner'), focusElement);
        }
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');
  }
}

if (!customElements.get('health-calc-drawer')) {
  customElements.define('health-calc-drawer', HealthCalcDrawer);
}

document.addEventListener('click', handleHealthCalcTriggerClick, true);
